import { Flex, Grid, GridItem, Skeleton } from "@chakra-ui/react";

const seatLayout = [
  [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
  [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
  [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
  [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
  [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
  [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
  [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
  [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
  [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
  [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
];
function SeatLayoutLoader() {
  return (
    <Flex
      direction="column"
      h="100%"
      w="100%"
      overflow="hidden"
      py={{ base: "1rem", md: "0.5rem" }}
      px={{ base: "0.5rem", sm: "1rem" }}
    >
      {seatLayout?.map((item, index) => (
        <Grid
          maxW="full"
          key={`seat_grid_${index}`}
          templateColumns={`repeat(${item.length},1fr)`}
          columnGap="1rem"
          mb={"1rem"}
        >
          {item?.map((seat, seatIndex) => {
            return (
              <GridItem gridColumn={seatIndex + 1} key={`seat_${seatIndex}`}>
                <Skeleton height="2.5rem" width="2.5rem" />
              </GridItem>
            );
          })}
        </Grid>
      ))}
      <Skeleton height="2rem" />
    </Flex>
  );
}

export default SeatLayoutLoader;
